var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "14px",
    viewBox: "0 0 24 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Caret-\\u2013-Solid",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2620821,0.5 L1.73791787,0.5 C1.12231793,0.5 0.77858193,1.13777345 1.15981641,1.57317648 L11.4218985,13.2493366 C11.7156366,13.5835545 12.2812385,13.5835545 12.5781015,13.2493366 L22.8401836,1.57317648 C23.2214181,1.13777345 22.8776821,0.5 22.2620821,0.5 Z",
    id: "Path",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretSolid);
export default __webpack_public_path__ + "static/media/Caret - Solid.c7745abd5785003c46817186e082fd31.svg";
export { ForwardRef as ReactComponent };